var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.002 1c0-.553.447-1 1-1h7.997c.553 0 1 .447 1 1 0 .553-.447 1-1 1h-.922l.356 4.631a5.25 5.25 0 0 1 2.484 2.96l.031.093c.103.307.05.641-.137.9-.188.26-.49.416-.812.416H1.002a1 1 0 0 1-.95-1.316l.032-.093a5.25 5.25 0 0 1 2.483-2.96L2.923 2h-.921c-.553 0-1-.447-1-1zm3.999 11H7v3a.999.999 0 1 1-2 0v-3z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.3964b0707bd8cbf6ce2f0219e6e9e45e.svg";
export { ForwardRef as ReactComponent };